var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpAero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30642 0.638605C6.83787 0.171246 6.07694 0.171246 5.60838 0.638605L0.810382 5.42436C0.465526 5.76834 0.364318 6.28057 0.55174 6.72923C0.739162 7.1779 1.17398 7.46953 1.66128 7.46953H11.2573C11.7408 7.46953 12.1794 7.1779 12.3668 6.72923C12.5542 6.28057 12.4493 5.76834 12.1082 5.42436L7.31017 0.638605H7.30642Z",
    fill: "#A5CB1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpAero);
export default __webpack_public_path__ + "static/media/upAero.30146728fbf2edc4f913ab20dd859be5.svg";
export { ForwardRef as ReactComponent };